export const greekLettersKeysProps = [
  {
    id: 'α',
    label: '\\alpha',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\alpha',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'β',
    label: '\\beta',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\beta',
      method: 'cmd',
    },
    group: 'greek',
  },

  {
    id: 'γ',
    label: '\\gamma',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\gamma',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'δ',
    label: '\\delta',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\delta',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'ε',
    label: '\\epsilon',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\epsilon',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'ζ',
    label: '\\zeta',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\zeta',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'η',
    label: '\\eta',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\eta',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'η',
    label: '\\eta',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\eta',
      method: 'cmd',
    },
    group: 'greek',
  },

  {
    id: 'θ',
    label: '\\theta',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\theta',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'ι',
    label: '\\iota',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\iota',
      method: 'cmd',
    },
    group: 'greek',
  },

  {
    id: 'κ',
    label: '\\kappa',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\kappa',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'λ',
    label: '\\lambda',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\lambda',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'μ',
    label: '\\mu',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\mu',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'ν',
    label: '\\nu',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\nu',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'ξ',
    label: '\\xi',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\xi',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'ο',
    label: 'o',
    labelType: 'tex',

    mathfieldInstructions: {
      content: 'o',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'π',
    label: '\\pi',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\pi',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'ρ',
    label: '\\rho',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\rho',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'σ',
    label: '\\sigma',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\sigma',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'τ',
    label: '\\tau',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\tau',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'υ',
    label: '\\upsilon',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\upsilon',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'φ',
    label: '\\phi',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\phi',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'χ',
    label: '\\chi',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\chi',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'ψ',
    label: '\\psi',
    labelType: 'tex',

    mathfieldInstructions: {
      content: 'psi',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'ω',
    label: '\\omega',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\omega',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'I',
    label: 'I',
    labelType: 'tex',

    mathfieldInstructions: {
      content: 'I',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'V',
    label: 'V',
    labelType: 'tex',

    mathfieldInstructions: {
      content: 'V',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'X',
    label: 'X',
    labelType: 'tex',

    mathfieldInstructions: {
      content: 'X',
      method: 'cmd',
    },
    group: 'greek',
  },
  {
    id: 'C',
    label: 'C',
    labelType: 'tex',

    mathfieldInstructions: {
      content: 'C',
      method: 'cmd',
    },
    group: 'greek',
  },
]
